export const getHoverColor = (x) => getPastelColor(x, 'd9');
export const getPastelColor = (x, alphaHex) => /^#.{6}$/.test(x?.toString() ?? '') ? `${x}${alphaHex ?? '2a'}` : x;
export function getLuminance(hex) {
    const isShorthand = hex.length === 4;
    const hexLong = isShorthand
        ? '#' +
            hex
                .slice(1, 4)
                .split('')
                .map(char => char + char)
                .join('')
        : hex;
    const r = parseInt(hexLong.slice(1, 3), 16) / 255;
    const g = parseInt(hexLong.slice(3, 5), 16) / 255;
    const b = parseInt(hexLong.slice(5, 7), 16) / 255;
    const a = [r, g, b].map(c => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)));
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}
export function getContrastRatio(lum1, lum2) {
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
}
//# sourceMappingURL=color.js.map